import { Box, Text, Flex } from '@chakra-ui/react'
import React from 'react';
import NavBar from '../../components/NavigationBar'
import Footer from '../../components/Footer';
import TeamDisplay from '../../components/Contact/TeamDisplay';

const ClosedDixieCove = () => {
  return (
    <Box maxWidth={"1250px"} mx={"auto"} bgColor={'#ffffff'}>
      <NavBar />

      <Box
        as="section"
        py="12"
        position="relative"
        h={{ base: '217px', md: '572px' }}
        bgImage="/Dixie Cove-Banner.png"
        bgSize="cover"
        bgPosition="center"
      >
        <Box
          maxW={{ base: 'xl', md: '7xl' }}
          mx="auto"
          px={{ base: '6', md: '8' }}
          h="full"
          zIndex={1}
          position="relative"
        >
        </Box>
        <Box
          display={{ base: 'none', md: 'block' }}
          position="absolute"
          zIndex={2}
          w="full"
          bottom="0"
          py="4"
        >
        </Box>

        <Text
          paddingTop={'3px'}
          paddingLeft={'10px'}
          style={{ position: 'absolute', bottom: '0', left: '0', right: '0' }}
          bg="gray.600"
          color="#F2F2F2"
          opacity={'.7'}
          height={['28%','30%','25%']}
          pl={'20%'}
          textAlign="left"
          fontFamily={'montserrat, sans-serif'}
        >
        </Text>
      </Box>

      <Text
        fontSize={['16px','16px','30px']}
        fontFamily={'montserrat, sans-serif'}
        align={['center','left','left']}
        pl={['0%','10%','10%']}
        position="relative"
        mt={['-55px','-59px','-120px']}
        color={'#F2F2F2'}
        fontWeight={'normal'}
      >
        <span style={{ fontWeight: 'bold' }}>Dixie Cove </span>| Salt Lake City, UT
      </Text>
      <Text
        fontSize={['13px','16px','22px']}
        fontFamily={'montserrat, sans-serif'}
        align={['center','left','left']}
        pl={['0%','10%','10%']}
        color={'#F2F2F2'}
        position="relative"
        mb={['8px','0px','40px']}
      >
        25 UNITS - COMPLETED IN 1973
      </Text>

      <Box
        as="section"
        py="12"
        position="relative"
        h={{ base: '475px', md: '330px' }}
        bgImage="/listing-team-background.png"
        bgSize="cover"
        bgPosition="center"
        bgColor={'#EAE6DC'}
        _after={{
          content: `""`,
          display: 'block',
          w: 'full',
          h: 'full',
          position: 'absolute',
          inset: 0,
          zIndex: 0,
        }}
      >
        <Text fontFamily={'montserrat, sans-serif'} fontSize={['20px','23px','32px']} fontWeight="bold" textAlign="center" mb="4">
          ADVISORY TEAM
        </Text>
        <Text fontFamily={'Noto Sans, sans-serif'} fontSize={["","2xl","2xl"]} fontWeight="bold" textAlign="center" mb="4">
          Marcus & Millichap
        </Text>
        <Flex flexDirection={['column','column','row']} justifyContent={'center'} mt={'1px'} alignItems={'center'}>
          <TeamDisplay
            imageSrc="/evan-clark.png"
            name="Evan Clark"
            title="Associate"
            number="801.736.2632"
            email="evan.clark@marcusmillichap.com"
            license="UT 10187590-SA00"
          />
          <TeamDisplay
            imageSrc="/jake-miles-circle.png"
            name="Jake Miles"
            title="Senior Associate"
            number="801.736.2654"
            email="jake.miles@marcusmillichap.com"
            license="UT 11449836-SA00, ID: SP53647"
          />
        </Flex>
      </Box>
      <Footer />
    </Box>
  );
};

export default ClosedDixieCove;
